// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CourseLessonExample-module--wrapper--muBos","item":"CourseLessonExample-module--item--y-go_"};